import { render, staticRenderFns } from "./seniorOne.vue?vue&type=template&id=42f142ca&scoped=true"
import script from "./seniorOne.vue?vue&type=script&lang=js"
export * from "./seniorOne.vue?vue&type=script&lang=js"
import style0 from "./seniorOne.vue?vue&type=style&index=0&id=42f142ca&prod&scoped=true&lang=less"
import style1 from "./seniorOne.vue?vue&type=style&index=1&id=42f142ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f142ca",
  null
  
)

export default component.exports